import { FC } from "react";
import { img } from "../../../assets/icon";
import {
  Image,
  RadioInput,
  RadioLabel,
  RadioText,
  ThumbaImage,
} from "./RadioImageBtn.styled";

type Props = {
  name: string;
  text: string;
  image: string;
  isChecked: boolean;
  onChange: (isChecked: boolean) => void;
  disabled?: boolean;
  className?: string;
};

export const RadioImageBtn: FC<Props> = ({
  name,
  text,
  image,
  isChecked,
  onChange,
  disabled = false,
  className = "",
}) => {
  return (
    <>
      <RadioLabel className={`${className}`}>
        <ThumbaImage>
          <Image src={image ?? img} title="answer photo" />
          <RadioInput
            name={name}
            type="radio"
            disabled={disabled}
            checked={isChecked}
            onChange={({ target }) => onChange(target.checked)}
          />
        </ThumbaImage>

        <RadioText>{text}</RadioText>
      </RadioLabel>
    </>
  );
};
